import React from 'react'
import MenuHeader from './MenuHeader'
import logo from "../../assets/images/logo.svg"
import { NavLink } from 'react-router-dom'

function Header() {
  return (
    <>
        <header className='main-header'>
            <div className='container'>
                <div className='flx-head'>
                    <div className='logo'>
                        <NavLink to= '/' >
                            <img src={logo} className='' alt='Choice Techlab' width={204} height={58}  />
                        </NavLink>
                    </div>
                    <MenuHeader />
                </div>
            </div>
        </header>
    </>
  )
}

export default Header